/**
 * @author lifei & gll
 * 功能：用户中心常量维护
 */

import * as func from '@/func'

const enumToList = func.enumToList()

/**
 * 功能：1-1、map 供应商性质
 */
export enum MapNature {
  内部 = 1,
  外部 = 2,
  虚拟 = 3,
}
/**
 * 功能：1-2、list 供应商性质
 */
export const ListNature = Object.freeze<TCommon.CustomDictItem[]>(enumToList({ MapNature }))

/**
 * 功能：2-1、map 客户类型
 */
export enum MapCustomerType {
  通用 = 0,
  图书馆 = 1,
  学校 = 2,
  '直营店/小连锁' = 3,
}
/**
 * 功能：2-2、list 客户类型
 */
export const ListCustomerType = Object.freeze<TCommon.CustomDictItem[]>(enumToList({ MapCustomerType }))

/**
 * 功能：3-1、map 业务组类型
 */
export enum MapBusGroupType {
  采购组 = 0,
  销售组 = 1,
}

/**
 * 功能：3-2、list 业务组类型
 */
export const ListBusGroupType = Object.freeze<TCommon.CustomDictItem[]>(enumToList({ MapBusGroupType }))

/**
 * 功能：4-1、map 供应商等级
 */
export enum MapSupplierLevel {
  一类 = 1,
  二类 = 2,
  三类 = 3,
  四类 = 4,
}

/**
 * 功能：4-2、list 供应商等级
 */
export const ListSupplierLevel = Object.freeze<TCommon.CustomDictItem[]>(enumToList({ MapSupplierLevel }))

/**
 * 功能：5-1、map 经济类型
 */
export enum MapEconomicNature {
  集团内组织 = 1,
  中外合资 = 2,
  民营企业 = 3,
  外资 = 4,
  个体工商户 = 5,
  国有企业独资及控股 = 6,
}

/**
 * 功能：5-2、list 经济类型
 */
export const ListEconomicNature = Object.freeze<TCommon.CustomDictItem[]>(enumToList({ MapEconomicNature }))

/**
 * 功能：6-1 菜单状态 map
 */
export enum MapMenuStatus {
  启用 = 0,
  禁用 = 1,
}

/**
 * 6-1、map 菜单类型（M目录 C菜单 F按钮 L列表 P权限方案）
 */
export enum MapMenuType {
  M = '目录',
  C = '菜单',
  F = '按钮权限',
  L = '字段权限',
  P = '数据权限',
  目录 = 'M',
  菜单 = 'C',
  按钮权限 = 'F',
  字段权限 = 'L',
  数据权限 = 'P',
}

/**
 * 6-1、用户操作
 */
export enum MapUserOperate {
  个人信息 = 0,
  切换组织 = 1,
  修改密码 = 2,
  我的组织 = 3,
}

/**
 * 账号状态
 */
export enum EnumUserCenterAccountStatus {
  Frozen = 0,
  normal = 1,
}
/**
 * 账号状态名称 0-'冻结' 1-'正常'
 */
export enum EnumUserCenterAccountStatusName {
  Frozen = '冻结',
  normal = '正常',
}
/**
 * 账号状态颜色
 */
export enum EnumUserCenterAccountStatusColor {
  Frozen = 'green',
  normal = 'red',
}

/**
 * 收货地址信息
 */
export enum EnumUserCenterAccountAddrStatus {
  school,
  family,
}

/**
 * 收货地址信息名称
 */
export enum EnumUserCenterAccountAddrStatusName {
  school = '学校',
  family = '家',
}

/**
 * 收货地址信息名称
 */
export enum EnumUserCenterAccountAddrStatusColor {
  school = 'blue',
  family = 'green',
}
/// 性别
export enum EnumUserSex {
  woman,
  man,
}
/// 性别名称
export enum EnumUserSexName {
  woman = '女',
  man = '男',
}
